/**
 * Type-guard for a string of an integer.
 *
 **/

export function isIntString(value: string): boolean {
    return value !== '' && !isNaN(Number(value)) && Number.isInteger(Number(value));
}
